var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.77847 8.02111C-0.517301 12.3169 -0.517301 19.2817 3.77847 23.5775L48.4515 68.2505L3.90385 112.798C-0.39192 117.094 -0.391921 124.059 3.90385 128.354L8.14649 132.597C12.4423 136.893 19.4071 136.893 23.7028 132.597L68.2505 88.0494L112.673 132.472C116.969 136.768 123.933 136.768 128.229 132.472L132.472 128.229C136.768 123.933 136.768 116.969 132.472 112.673L88.0494 68.2505L132.597 23.7026C136.893 19.4068 136.893 12.442 132.597 8.14627L128.355 3.90363C124.059 -0.39214 117.094 -0.39214 112.798 3.90363L68.2505 48.4515L23.5775 3.77847C19.2817 -0.517301 12.3169 -0.517301 8.02111 3.77847L3.77847 8.02111Z",
    fill: "#FF006B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReject);
export default __webpack_public_path__ + "static/media/reject.df58c81181cbf189f2a0cc3e81830445.svg";
export { ForwardRef as ReactComponent };